import React from 'react';

const categories = ["Todo", "Novedades", "Frontend", "Backend", "IA", "Diseño", "DevOps", "Móvil", "Seguridad"];

const CategoryPills = ({ selected, onSelect }) => {
  return (
    <div className="w-full bg-transparent border-b border-white/5 py-3 mb-6">
      <div className="max-w-7xl mx-auto px-4 overflow-x-auto scrollbar-hide">
        <div className="flex gap-3 min-w-max">
          {categories.map((cat) => (
            <button
              key={cat}
              
              onClick={() => onSelect && onSelect(cat === "Todo" ? "" : cat)}
              className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all ${
                (selected === cat || (cat === "Todo" && selected === "")) 
                  ? 'bg-slate-900 dark:bg-white text-white dark:text-slate-900' 
                  : 'bg-slate-100 dark:bg-white/10 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-white/20'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryPills;